/**
 * Backend /upgrades enums arrive as snake_case (`double_strike`,
 * `modes_choose`, `card_enters`, `opponents_library`) or camelCase
 * (`triggerChoice`, `outsideOfGame`). Neither reads as English. This
 * helper normalizes both into space-separated lowercase words for
 * display only — the underlying value sent to the API never changes.
 */
export const humanizeUpgradesEnum = (s) =>
    String(s || '')
        .replace(/_/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .toLowerCase();
